import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { BprofileService } from "@app/b-profile/services";
import { MatListModule, MatSelectionList } from '@angular/material/list';
import { NgFor } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { IService } from "@app/core/interfaces";
import { Subject, takeUntil } from "rxjs";
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { CloseIconComponent } from "../../../../shared/icons/close-icon.component";



@Component({
    templateUrl: './select-services.component.html',
    styleUrls: ['./select-services.component.css'],
    standalone: true,
    imports: [MatListModule, NgFor, TranslateModule, FormsModule, CloseIconComponent],
})
export class SelectServicesModalComponent implements OnInit {

    private unsubscribe$: Subject<void> = new Subject<void>();
    @ViewChild('services', { static: false }) servicesList: MatSelectionList;

    @Input() public selectedServices: Array<IService>;
    public allServices: Array<IService>;
    constructor(private servicesServie: BprofileService,
        public activeModal: NgbActiveModal) {

    }

    ngOnInit(): void {
        this.servicesServie.getServices()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(res => this.allServices = res);
        if (!this.selectedServices) {
            this.selectedServices = new Array<IService>();
        }
    }


    public isSelected(service: IService): boolean {
        return this.selectedServices.some(s => s.id == service.id);
    }



    public save(): void {
        this.activeModal.close(this.servicesList.selectedOptions.selected.map(o=>o.value));
    }
}